module.exports = __webpack_public_path__ + "img/purim-2017.428dfb25.jpg";